import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import DisplayModeSetting from '@components/cockpit/panels/settings/DisplayModeSetting';
import PerimeterSettings from '@components/cockpit/panels/settings/PerimeterSettings';
import LogoutButton from '@components/login/LogoutButton';
import { ScrollArea } from '@components/ui/ScrollArea';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveProfile, selectActiveUser } from '@redux/authent/authent.selectors';
import { selectActiveGlobalScreenConfiguration } from '@redux/config/config.selectors';
import { capitalize } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

import CockpitPanelHeader from '../CockpitPanelHeader';
import Panel from '../Panel';
import CameraSettings from './CameraSettings';
import LanguageSettings from './LanguageSettings';
import MiscellaneousSettings from './MiscellaneousSettings';
import UnitsSettings from './UnitsSettings';

export default function ProfileUserParams() {
  const { formatMessage } = useIntl();
  const { login, name, firstName } = useAppSelector(selectActiveUser);
  const globalScreenConfig = useAppSelector(selectActiveGlobalScreenConfiguration);

  const activeProfile = useAppSelector(selectActiveProfile);

  return (
    <Panel header={<CockpitPanelHeader label={formatMessage({ id: 'components.sidebar.SETTINGS' })} />}>
      <HStack width="100%" height="100%" gap={0}>
        <VStack
          height="100%"
          width="293px"
          backgroundColor="neutral.700"
          padding={4}
          gap={3}
          alignItems="start"
          flexShrink={0}
        >
          <VStack gap={1} alignItems="start">
            <Text color="neutral.300" textStyle="md" fontWeight="medium">
              <FormattedMessage id="authent.user.profile" />
            </Text>
            <Text color="neutral.white" textStyle="md" fontWeight="medium">
              {capitalize(activeProfile?.name)}
            </Text>
          </VStack>
          <VStack gap={1} alignItems="start">
            <Text color="neutral.300" textStyle="md" fontWeight="medium">
              <FormattedMessage id="authent.user.config" />
            </Text>
            <Text color="neutral.white" textStyle="md" fontWeight="medium">
              {capitalize(globalScreenConfig?.name)}
            </Text>
          </VStack>
          <VStack gap={1} alignItems="start">
            <Text color="neutral.300" textStyle="md" fontWeight="medium">
              <FormattedMessage id="authent.user.login" />
            </Text>
            <Text color="neutral.white" textStyle="md" fontWeight="medium">
              {login}
            </Text>
          </VStack>
          <VStack gap={1} alignItems="start">
            <Text color="neutral.300" textStyle="md" fontWeight="medium">
              <FormattedMessage id="authent.user.fullName" />
            </Text>
            <Text color="neutral.white" textStyle="md" fontWeight="medium">{`${firstName} ${name}`}</Text>
          </VStack>
          <VStack gap={2} alignItems="start" width="100%" marginTop="auto">
            <Button variant="secondary" width="100%" disabled>
              <FormattedMessage id="components.userSettings.changePassword" />
            </Button>
            <LogoutButton />
          </VStack>
        </VStack>
        <ScrollArea>
          <VStack width="100%" height="100%" backgroundColor="neutral.700" gap={0.25}>
            <HStack width="100%" backgroundColor="neutral.700" gap={0.25}>
              <DisplayModeSetting />
              <LanguageSettings />
              <UnitsSettings />
              <MiscellaneousSettings />
            </HStack>
            <CameraSettings />
            <PerimeterSettings />
            <HStack width="100%" padding={2} marginTop="auto">
              <Button marginLeft="auto" variant="secondary" disabled>
                <FormattedMessage id="components.userSettings.resetSettings" />
              </Button>
            </HStack>
          </VStack>
        </ScrollArea>
      </HStack>
    </Panel>
  );
}
